import { Link } from "react-router-dom";

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 via-white to-white flex flex-col items-center justify-center px-6 py-24 text-center">
      <div className="max-w-2xl space-y-6">
        <span className="inline-flex items-center rounded-full bg-emerald-100 px-4 py-1 text-sm font-semibold text-emerald-800">
          Access paused
        </span>
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900">
          Authentication is coming soon
        </h1>
        <p className="text-lg text-slate-600">
          We are making improvements to our sign in and sign up experience. While we finish the updates, login and registration are temporarily unavailable.
        </p>
        <p className="text-base text-slate-500">
          Have questions or need help? Reach out to our team at{" "}
          <a className="text-emerald-600 underline" href="mailto:hello@nomerahealth.com">
            hello@nomerahealth.com
          </a>
          .
        </p>
        <Link
          to="/"
          className="inline-flex h-11 items-center justify-center rounded-xl bg-emerald-600 px-6 text-base font-semibold text-white shadow-sm transition hover:bg-emerald-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
